export const reviewCategories = [
  { id: "all", label: "全部测评" },
  { id: "delivery", label: "外卖测评" },
  { id: "store", label: "探店实录" },
  { id: "unbox", label: "美食开箱" },
  { id: "home", label: "家常复刻" },
] as const;

export type ReviewCategory = "delivery" | "store" | "unbox" | "home";

export interface ReviewItem {
  id: string;
  title: string;
  category: ReviewCategory;
  rating: number;
  price: string;
  author: string;
  date: string;
  excerpt: string;
  tags: string[];
  readTime: string;
  image: string;
  highlight: string;
}

export const reviews: ReviewItem[] = [
  {
    id: "r1",
    title: "32元吃到整只脆皮烤鸡腿饭，这家社区小馆的外卖踩不踩雷",
    category: "delivery",
    rating: 4.6,
    price: "¥32",
    author: "口味调查员·阿禾",
    date: "2026-09-28",
    excerpt:
      "从下单到送达用了27分钟，鸡腿皮还是脆的。米饭偏干，但酱汁给得足，搭配的腌萝卜解腻刚好。整体超出同价位外卖平均水平。",
    tags: ["烤鸡腿饭", "出餐快", "分量足"],
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Crispy%20glazed%20chicken%20drumstick%20over%20steamed%20rice%20in%20a%20takeout%20box%20with%20pickled%20radish%2C%20warm%20appetizing%20food%20photography%2C%20soft%20natural%20light%2C%20neutral%20beige%20background%2C%20top%20down%2C%20high%20detail&width=800&height=600&seq=food-review-chicken-rice-01&orientation=landscape",
    highlight: "皮脆不塌，出餐仅27分钟",
  },
  {
    id: "r2",
    title: "深夜探访老巷子里的现包馄饨摊：一晚卖出400碗的秘诀",
    category: "store",
    rating: 4.9,
    price: "¥15",
    author: "探店小队·小满",
    date: "2026-09-25",
    excerpt:
      "晚上十点仍排着队。馄饨皮薄到能看见内馅，汤底用猪骨熬足四小时。老板坚持现包现煮，等位虽久，但那一口鲜是连锁店给不了的。",
    tags: ["现包馄饨", "深夜食堂", "排队摊"],
    readTime: "8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20freshly%20wrapped%20wontons%20in%20pork%20broth%20at%20a%20night%20street%20stall%2C%20warm%20lantern%20light%2C%20rustic%20wooden%20table%2C%20cozy%20nostalgic%20food%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=food-review-wonton-stall-02&orientation=landscape",
    highlight: "现包现煮，一晚四百碗",
  },
  {
    id: "r3",
    title: "开箱测评：99元冷冻麻辣小龙虾套餐，解冻后还原度有多高",
    category: "unbox",
    rating: 4.2,
    price: "¥99",
    author: "开箱组·老周",
    date: "2026-09-22",
    excerpt:
      "冰袋完好，虾身完整率约九成。加热后麻辣味偏温和，蒜香明显。适合宅家聚餐，但壳偏软，追求弹牙口感的话还是堂食更稳。",
    tags: ["冷冻小龙虾", "宅家聚餐", "还原度"],
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Spicy%20sichuan%20crayfish%20in%20a%20takeout%20tray%20with%20garlic%20and%20chili%2C%20freshly%20reheated%20and%20glossy%2C%20warm%20red%20tones%2C%20clean%20neutral%20background%2C%20appetizing%20food%20photography%2C%20high%20detail&width=800&height=600&seq=food-review-crayfish-box-03&orientation=landscape",
    highlight: "完整率九成，蒜香突出",
  },
  {
    id: "r4",
    title: "复刻外卖爆款「蒜香黄油虾仁意面」，在家成本不到20元",
    category: "home",
    rating: 4.7,
    price: "¥18",
    author: "厨房实验台·林一",
    date: "2026-09-20",
    excerpt:
      "关键在黄油和蒜末的比例，2:1 最稳。虾仁用盐和黑胡椒腌十分钟，下锅前擦干水分才能煎出焦边。全程15分钟出锅。",
    tags: ["意面复刻", "15分钟", "性价比"],
    readTime: "9 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Garlic%20butter%20shrimp%20pasta%20on%20a%20white%20ceramic%20plate%2C%20glossy%20sauce%2C%20parsley%20garnish%2C%20warm%20cozy%20home%20kitchen%20lighting%2C%20neutral%20beige%20background%2C%20editorial%20food%20photography&width=800&height=600&seq=food-review-shrimp-pasta-04&orientation=landscape",
    highlight: "2:1 蒜黄比例，15分钟出锅",
  },
  {
    id: "r5",
    title: "连锁奶茶新品横评：五杯同价，谁家的茶底最扎实",
    category: "delivery",
    rating: 4.4,
    price: "¥19",
    author: "口味调查员·阿禾",
    date: "2026-09-18",
    excerpt:
      "同一时段用同一地址下单五家。茶底浓度差异明显，两家茶味寡淡靠糖撑，一家奶盖厚实但不腻。综合性价比给出了明确排序。",
    tags: ["奶茶横评", "茶底", "同价对比"],
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Five%20cups%20of%20milk%20tea%20lined%20up%20on%20a%20light%20wooden%20table%2C%20creamy%20cheese%20foam%20topping%2C%20soft%20daylight%2C%20minimal%20clean%20beige%20background%2C%20bright%20refreshing%20food%20photography&width=800&height=600&seq=food-review-milk-tea-lineup-05&orientation=landscape",
    highlight: "同地址同价横评五家",
  },
  {
    id: "r6",
    title: "探店：藏在菜市场二楼的广式烧腊，叉烧为什么能卖到脱销",
    category: "store",
    rating: 4.8,
    price: "¥45",
    author: "探店小队·小满",
    date: "2026-09-15",
    excerpt:
      "烧腊挂炉每天上午十点出炉。叉烧外层焦糖化，肥瘦比约三七。老板说腌制要过夜，糖浆要刷三遍。人均45元吃到满足。",
    tags: ["广式烧腊", "菜市场美食", "叉烧"],
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Glossy%20cantonese%20bbq%20pork%20char%20siu%20sliced%20on%20a%20plate%2C%20caramelized%20edges%2C%20warm%20amber%20lighting%2C%20rustic%20market%20kitchen%20setting%2C%20appetizing%20food%20photography%2C%20high%20detail&width=800&height=600&seq=food-review-char-siu-06&orientation=landscape",
    highlight: "每日十点出炉，三七肥瘦",
  },
  {
    id: "r7",
    title: "开箱：69元六盒自热火锅组合，辣度与食材逐盒实拍",
    category: "unbox",
    rating: 4.0,
    price: "¥69",
    author: "开箱组·老周",
    date: "2026-09-12",
    excerpt:
      "六盒口味不重样，发热包稳定。宽粉吸汤但易糊底，建议先放蔬菜后放主食。整体胜在方便，适合出差和露营场景。",
    tags: ["自热火锅", "六盒组合", "出差必备"],
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Self%20heating%20hot%20pot%20box%20with%20vegetables%20and%20wide%20noodles%20steaming%2C%20spicy%20red%20broth%2C%20clean%20neutral%20background%2C%20warm%20practical%20food%20photography%2C%20high%20detail&width=800&height=600&seq=food-review-hotpot-box-07&orientation=landscape",
    highlight: "六盒不重样，发热稳定",
  },
  {
    id: "r8",
    title: "复刻夜宵摊「孜然铁板鱿鱼」，掌握火候就能复刻街头味",
    category: "home",
    rating: 4.5,
    price: "¥22",
    author: "厨房实验台·林一",
    date: "2026-09-09",
    excerpt:
      "鱿鱼先焯水去腥，铁板要够热再下锅。孜然粒和辣椒面最后撒，香气才立得住。家里没有铁板，用厚底平底锅也能出焦香。",
    tags: ["铁板鱿鱼", "夜宵复刻", "火候"],
    readTime: "8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Sizzling%20grilled%20squid%20with%20cumin%20and%20chili%20on%20a%20hot%20iron%20plate%2C%20smoke%20and%20char%20marks%2C%20warm%20night%20market%20lighting%2C%20appetizing%20street%20food%20photography&width=800&height=600&seq=food-review-cumin-squid-08&orientation=landscape",
    highlight: "焯水去腥，铁板够热",
  },
  {
    id: "r9",
    title: "外卖早餐测评：三家同城的现磨豆浆油条，谁更扛饿",
    category: "delivery",
    rating: 4.3,
    price: "¥12",
    author: "口味调查员·阿禾",
    date: "2026-09-06",
    excerpt:
      "早晨六点半下单，最快一家18分钟送达。豆浆浓度实测差别不小，一家明显掺水。油条复脆程度和包装方式直接相关。",
    tags: ["早餐测评", "现磨豆浆", "油条"],
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20breakfast%20of%20fresh%20soy%20milk%20and%20golden%20fried%20dough%20sticks%20on%20a%20tray%2C%20morning%20soft%20light%2C%20warm%20neutral%20background%2C%20clean%20appetizing%20food%20photography&width=800&height=600&seq=food-review-breakfast-09&orientation=landscape",
    highlight: "最快18分钟送达",
  },
];